import { guaranies } from '../datos/formato.js'
import type { SolapaPaciente } from './navegacion.js'

/**
 * El banner del paciente abierto.
 *
 * Presentacional puro: no lee de Dexie, no hace red. Las solapas van acá y no
 * en una barra aparte porque son del paciente, no del módulo: cambiarse de
 * módulo no las cierra. El saldo va acá porque es lo que decide la conversación
 * en el mostrador, y tiene que estar a la vista en las cuatro solapas.
 */

/**
 * Cuatro solapas, en el orden que sigue la historia del paciente: lo que se
 * sabe de él, lo que se le hizo, después la plata y por último el calendario.
 */
const SOLAPAS: { id: SolapaPaciente; etiqueta: string }[] = [
  { id: 'ficha', etiqueta: 'Ficha' },
  { id: 'anamnesis', etiqueta: 'Anamnesis' },
  { id: 'odontograma', etiqueta: 'Odontograma' },
  { id: 'cuenta', etiqueta: 'Cuenta' },
  { id: 'citas', etiqueta: 'Citas' },
]
export function BannerPaciente({
  nombre,
  telefono,
  deuda,
  edad,
  esMenor,
  solapa,
  onSolapa,
  onCerrar,
}: {
  nombre: string
  telefono: string | null
  /** Saldo impago del paciente, en guaraníes. `0` = al día. */
  deuda: number
  edad: string | null
  esMenor: boolean
  solapa: SolapaPaciente
  onSolapa: (s: SolapaPaciente) => void
  onCerrar: () => void
}) {
  return (
    <div className="sticky top-0 z-30 border-b border-slate-200 bg-white px-4 py-2">
      <div className="flex items-center gap-3">
        <span className="min-w-0 flex-1 truncate font-medium text-slate-900">{nombre}</span>
        {edad && <span className="shrink-0 text-sm font-medium text-slate-600">{edad}</span>}
        {esMenor && <span className="shrink-0 rounded bg-rose-600 px-2 py-1 text-xs font-bold text-white">PACIENTE MENOR</span>}
        {telefono && (
          <span className="shrink-0 text-sm text-slate-500">{telefono}</span>
        )}
        {deuda > 0 && (
          <span className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
            Debe {guaranies(deuda)}
          </span>
        )}
        <button
          type="button"
          onClick={onCerrar}
          className="ml-auto shrink-0 text-lg text-slate-400 hover:text-slate-700"
          aria-label="Cerrar paciente"
        >
          ×
        </button>
      </div>

      <div className="mt-1.5 flex flex-wrap gap-1">
        {SOLAPAS.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onSolapa(s.id)}
            className={`rounded-md px-3 py-1 text-sm transition ${
              solapa === s.id
                ? 'bg-teal-700 font-medium text-white'
                : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            {s.etiqueta}
          </button>
        ))}
      </div>
    </div>
  )
}
